import { render, staticRenderFns } from "./AgeConfirmationForm.vue?vue&type=template&id=bee3b6d6&"
import script from "./AgeConfirmationForm.vue?vue&type=script&lang=ts&"
export * from "./AgeConfirmationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports